'use client'

import {useEffect} from 'react';

const LiveInternetMetrika = () => {
    useEffect(() => {
        // Создаем тег изображения для счетчика LiveInternet
        const counterImg = document.createElement('img');
        counterImg.src = `//counter.yadro.ru/hit?t16.2;r${escape(document.referrer)};` +
            `s${screen.width}*${screen.height}*${(screen.colorDepth || screen.pixelDepth)};` +
            `u${escape(document.URL)};` +
            `h${escape(document.title.substring(0, 80))};${Math.random()}`;
        counterImg.alt = "LiveInternet: показано число просмотров за 24 часа, посетителей за 24 часа и за сегодня";
        counterImg.width = 88;
        counterImg.height = 31;
        counterImg.classList.add('hidden')

        // Создаем ссылку для счетчика
        const counterLink = document.createElement('a');
        counterLink.href = 'http://www.liveinternet.ru/click';
        counterLink.target = '_blank';
        counterLink.appendChild(counterImg);

        // Добавляем ссылку в body
        document.body.appendChild(counterLink);

        // Удаление ссылки с изображением при размонтировании компонента
        return () => {
            if (document.body.contains(counterLink)) {
                document.body.removeChild(counterLink);
            }
        };
    }, []);

    return null;
};

export default LiveInternetMetrika;
